<div class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Secciones </div>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>



            <!-- CONTENT -->
            <div class="content">

                <div class="container-table">
                    <mat-table #table [dataSource]="dataItems.data" [@animateStagger]="{value:'50'}">

                        <ng-container *ngFor="let column of configColumns" [matColumnDef]="column.key">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>{{ column.title }}</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container *ngIf="column.type == 'integer' || column.type == 'string'">
                                    <p [ngClass]="{'text-truncate': column.type == 'integer'}" class="{{ column.classes }}">{{ item[column.field_key] }}</p>
                                </ng-container>

                                <ng-container *ngIf="column.type == 'money'">
                                    <p class="{{ column.classes }}">{{ item[column.field_key] | currency }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>
                        

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="actions" stickyEnd>
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let item">
                                <div fxFlex="row" fxLayoutAlign="end center">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="Acciones" (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #moreMenu="matMenu">
                                        <button [routerLink]="'/section-view/' + item.id" mat-menu-item aria-label="edit">
                                                <mat-icon>edit</mat-icon>
                                                <span>Ver</span>
                                            </button>
                                    </mat-menu>
                                </div>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let item; columns: displayedColumns;" class="item" (click)="openItem(item)" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                        </mat-row>
                    </mat-table>
                </div>


                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </mat-card>



            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>